module.exports = __webpack_public_path__ + "media/images/flags/32/Namibia-763f97be197ece5bd6caad02a11f0c6f.png";